function hiddenNotices() {
    let hidden = [];
    try {
        hidden = JSON.parse($.cookie('bw_hidden_notices'));
    } catch (e) {}
    return Array.isArray(hidden) ? hidden : [];
}

const hiddenOnLoad = hiddenNotices();
$('.b-element').filter((i, el) => !hiddenOnLoad.includes(el.id)).removeClass('d-none');

$('[data-close-notice]').click(function(){
    const el = $(this).closest('.b-element');
    el.addClass('hiding').on('transitionend',() => el.remove());

    if (!bwCookieAllowed('bw_hidden_notices', window.bwGranted)) return;

    const cookiesForBanners = hiddenNotices();
    cookiesForBanners.push(el.attr('id'));

    $.cookie('bw_hidden_notices', JSON.stringify(cookiesForBanners), {
            path: '/', secure: true
        });
})